import {AfterViewInit, Component, Input, OnInit, OnChanges, SimpleChange} from '@angular/core';
import {PointOfSaleDto} from "../point-of-sale-dto";
import {LoggerService} from "../../../core/logger.service";
import {CityCodeEnum} from "../city-code.enum";
import {AirportCodeEnum} from "../airport-code.enum";
import {FormControl, Validators} from "@angular/forms";

@Component({
    selector: 'delivery-instructions',
    templateUrl: './delivery-instructions.component.html',
    providers: []
})
export class DeliveryInstructionsComponent implements OnInit, OnChanges{

    @Input() errors;
    @Input() errorMessages;
    @Input() dto:PointOfSaleDto;
    @Input() countryId:number;
    @Input() hasOtherDeliveryMessage:boolean=false;
    @Input() enabledCity;
    @Input() isPointOfSale;
    @Input() isValidLocation;

    errorsToChild={};

    constructor(private logger: LoggerService) {
    }

    ngOnInit(): void {
        this.checkingIndications();
        this.logger.info('PointOfSaleDeliveryInstructions: logger.info()' + JSON.stringify(this.dto));
    }

    ngOnChanges(changes:  {[propKey: string]: SimpleChange}): void {

        let errorsFromParent = changes['errors'];
        if(errorsFromParent){
            this.errorsToChild = errorsFromParent.currentValue.posPickupIndications;
        }
    }

    checkingIndications() {
        if(this.dto.pickupIndications && this.isSpecialAirport(this.dto.locationOid) && this.isPointOfSale) {
            if(this.dto.pickupIndications.meetingType === 'COUNTER'){
                if(!this.dto.pickupIndications.additionalInstructions){
                    this.dto.pickupIndications.meetingType="";
                }
            }
            else {
                this.dto.pickupIndications.meetingType="";
                this.dto.pickupIndications.additionalInstructions="";
            }
        }
    }

    showIndicationsCards(locationOid, isPointOfSale):boolean {
        return isPointOfSale || (!isPointOfSale && !this.isSpecialAirport(locationOid));
    }

    isSpecialAirport(locationOid):boolean {
        return (locationOid == AirportCodeEnum.MIAMI_AIRPORT
            || locationOid == AirportCodeEnum.CANCUN_AIRPORT
            || locationOid == AirportCodeEnum.ORLANDO_AIRPORT);
    }

    showIndicationsPhone(locationOid, isPointOfSale):boolean {
        return !isPointOfSale && this.isSpecialAirport(locationOid);
    }

    isMiamiAirport(locationOid):boolean {
        return locationOid == AirportCodeEnum.MIAMI_AIRPORT;
    }

    isOrlandoAirport(locationOid):boolean {
        return locationOid == AirportCodeEnum.ORLANDO_AIRPORT;
    }

    isCancunAirport(locationOid):boolean {
        return locationOid == AirportCodeEnum.CANCUN_AIRPORT;
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/pointOfSale/delivery-instructions/delivery-instructions.component.ts